export function fmtMs(ms: number | null | undefined): string {
  if (ms == null || !isFinite(ms)) return '—';
  return ms < 1000 ? ms.toFixed(1) + ' ms' : (ms / 1000).toFixed(2) + ' s';
}

export function fmtInt(n: number | null | undefined): string {
  if (n == null || !isFinite(n)) return '—';
  return String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function fmtBytes(bytes: number | null | undefined): string {
  if (bytes == null || !isFinite(bytes)) return '—';
  const units = ['B', 'KB', 'MB', 'GB'];
  let i = 0;
  let v = bytes;
  while (v >= 1024 && i < units.length - 1) {
    v /= 1024;
    i++;
  }
  return (i === 0 ? v.toFixed(0) : v.toFixed(1)) + ' ' + units[i];
}

export function now(): number {
  return performance && performance.now ? performance.now() : Date.now();
}

export function clamp(n: number, min: number, max: number): number {
  return Math.max(min, Math.min(max, n));
}
